import React from 'react';
import s from './styles.module.css.json';
export var Group = function (_a) {
    var children = _a.children, name = _a.name;
    return (React.createElement("div", null,
        React.createElement("div", { className: s.Dropdown__menu__group__title }, name),
        React.createElement("div", { className: s.Dropdown__menu__group__content }, children)));
};
//# sourceMappingURL=Group.js.map